import { useEffect } from 'react';

export interface SeoMetaOptions {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  canonicalUrl?: string;
  noIndex?: boolean;
}

function setMetaTag(name: string, content: string, attribute: 'name' | 'property' = 'name') {
  if (!content) return;
  let el = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, name);
    document.head.appendChild(el);
  }
  el.content = content;
}

function setLinkTag(rel: string, href: string) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

export function applySeoMeta(options: SeoMetaOptions) {
  if (options.title) {
    document.title = options.title;
  }
  setMetaTag('description', options.description ?? '');
  setMetaTag('keywords', options.keywords ?? '');
  setMetaTag('og:title', options.ogTitle ?? options.title ?? '', 'property');
  setMetaTag('og:description', options.ogDescription ?? options.description ?? '', 'property');
  if (options.ogImage) {
    setMetaTag('og:image', options.ogImage, 'property');
  }
  setLinkTag('canonical', options.canonicalUrl ?? '');
  setMetaTag('robots', options.noIndex ? 'noindex, nofollow' : 'index, follow');
}

export function useSeoMeta(options: SeoMetaOptions) {
  useEffect(() => {
    applySeoMeta(options);
  }, [
    options.title,
    options.description,
    options.keywords,
    options.ogTitle,
    options.ogDescription,
    options.ogImage,
    options.canonicalUrl,
    options.noIndex,
  ]);
}
